import TableDisplayFields from "@common/components/tableDisplayFields/TableDisplayFields";
import ExcelExportButton from "@common/components/excelExportButton/ExcelExportButton";
import { TableFields } from "@common/components/tableDisplayFields/TableFields.types";
import { FieldGroupingType } from "@common/components/filterPopover/FilterPopover.types";
import { ClientFilteredPageView } from "@common/pageView/useClientFilteredPageView";
import { useTranslation } from "@localization/useTranslation";
import { usePlanContext } from "../../../auth/planProvider/PlanProvider";

export interface SavedViewControlsProps<TColumn extends string> {
    pageView: ClientFilteredPageView<TColumn>;
    tableFields: Array<TableFields>;
    groupingOrder: Array<FieldGroupingType>;
    isLoading: boolean;
    onExportClick: () => void;
}

// The column picker and the export button of a table whose saved views come from useClientFilteredPageView. Export is
// an add-on, so without custom lists the button shows locked. The view menu itself is SavedViewPicker.
function SavedViewControls<TColumn extends string>(props: SavedViewControlsProps<TColumn>) {
    const { translateString } = useTranslation();
    const { addonsFeatures } = usePlanContext();
    const view = props.pageView;

    if (!view.savedView) {
        return null;
    }

    return (
        <>
            <TableDisplayFields
                selectedFields={view.visibleColumns}
                onSave={view.onColumnsSave}
                options={props.tableFields}
                hasDisplayChanged={view.hasDisplayChanged}
                isCustomView={view.isSavedView}
                savedViewFields={view.savedView.displayData}
                groupingOrder={props.groupingOrder}
            />
            <ExcelExportButton
                onClick={props.onExportClick}
                isDisabled={props.isLoading}
                isPlanLocked={!addonsFeatures.customLists}
                planLockedText={translateString("upgradeToCustomList")}
            />
        </>
    );
}

export default SavedViewControls;
